export default __webpack_public_path__ + "static/media/limb_main.9ad26d63.jpg";